import { render, staticRenderFns } from "./bestFollowupCase.vue?vue&type=template&id=aca1937c&scoped=true&"
import script from "./bestFollowupCase.vue?vue&type=script&lang=js&"
export * from "./bestFollowupCase.vue?vue&type=script&lang=js&"
import style0 from "./bestFollowupCase.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./bestFollowupCase.vue?vue&type=style&index=1&id=aca1937c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca1937c",
  null
  
)

export default component.exports